import TextAndImageSection from "../../componets/TextAndImageSection";

export default function Section6() {
  return (
    <TextAndImageSection
      sectionName="Section6"
      containerName="section6"
      title="Elevate Your Brand with Exceptional Design"
      text="Ready to make your brand shine? Let's collaborate on a design that captures the essence of your business and connects with your audience. Contact Us today to discuss your project and discover how our design services can elevate your brand."
      imgUrl="assets/mobile-logo-and-branding.png"
      dividerMargin=" mt-[1%] md:mt-[5%]"
      btnLink="https://mean3.com/contact-mean3/"
    />
  );
}
